module.exports = __webpack_public_path__ + "img/ground.3901deaf.png";